import { Stack, TextField } from "@mui/material";
import { FC, memo, useCallback, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useListaFiliali } from "../../../../api/lista-filiali";
import { AppDispatch } from "../../../../../../store";
import { useDispatch } from "react-redux";
import { setIsLoadingForm } from "../../../../store/root";
import { nanoid } from "nanoid";
import { BluAutoComplete } from "@bludata/components";

interface ImoCodiceLayoutInterface {
  disabled: boolean;
}

export const ImoCodiceLayoutFiliale: FC<ImoCodiceLayoutInterface> = memo(
  ({ disabled }) => {
    const imoCodicePdvLayout = useWatch({ name: "imoCodicePdvLayout" });
    const { data, isLoading } = useListaFiliali();
    const dispatch: AppDispatch = useDispatch();

    const { setValue } = useFormContext();

    useEffect(() => {
      dispatch(setIsLoadingForm({ key: "listaFiliali", value: isLoading }));
    }, [dispatch, isLoading]);

    // const handleOnChange = useCallback(
    //   (event: any) => {
    //     setValue("imoCodicePdvLayout", event.target.value);
    //   },
    //   [setValue]
    // );

    const handleOnChange = useCallback(
      (_: any, newValue: any) => {
        if (newValue) {
          setValue("imoCodicePdvLayout", newValue.filiale);
        } else setValue("imoCodicePdvLayout", "");
      },
      [setValue]
    );

    const getValue = useCallback(() => {
      if (data && imoCodicePdvLayout) {
        const layout = data?.find(
          (option: any) => imoCodicePdvLayout === option.filiale
        );
        if (layout) {
          return layout;
        }
      }
      return null;
    }, [data, imoCodicePdvLayout]);

    return (
      <Stack flex="1">
        <Stack flex="1"></Stack>
        <BluAutoComplete
          value={getValue()}
          onChange={handleOnChange}
          data={data ?? []}
          getOptionLabel={(data: any) => {
            return `${data.nome} - ${data.codiceInterno}`;
          }}
          // disableClearable
          disabled={disabled}
          sx={{ flex: 1 }}
          renderOption={(props: any, option: any) => {
            return (
              <li {...props} key={nanoid()}>
                {`${option.nome} - ${option.codiceInterno}`}
              </li>
            );
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            return option && value && option.filiale === value.filiale;
          }}
          renderInput={(params: any) => (
            <TextField {...params} label="Filiale" disabled={disabled} />
          )}
        />
      </Stack>
    );
  }
);
